module.exports = __webpack_public_path__ + "img/instagram.11cb1156.svg";